import { Badge } from "@/components/ui/badge";
import type { TimeOff } from "@/features/calendar/types";
import type { ColumnDef } from "@tanstack/react-table";
import { useDateFormat, useTranslation } from "@/features/utils/i18n";
import { Action } from "./timeoffs-action";

export function useTimeOffColumns() {
  const { t } = useTranslation("schedules");
  const { format } = useDateFormat();

  const columns: ColumnDef<TimeOff>[] = [
    {
      accessorKey: "reason",
      header: t("closures.table.reason"),
      cell: ({ row }) => (
        <div className="font-medium">
          {row.original.reason || t("closures.table.noReason")}
        </div>
      ),
    },
    {
      accessorKey: "start_date",
      header: t("closures.table.startDate"),
      cell: ({ row }) => {
        const date = new Date(row.original.start_date);
        return <span>{format(date, "PP")}</span>;
      },
    },
    {
      accessorKey: "end_date",
      header: t("closures.table.endDate"),
      cell: ({ row }) => {
        const date = new Date(row.original.end_date);
        return <span>{format(date, "PP")}</span>;
      },
    },
    {
      id: "affected_members",
      header: t("closures.table.affectedMembers"),
      cell: ({ row }) => {
        const members = row.original.affected_members?.id || [];
        if (members.length === 0) {
          return (
            <Badge variant="secondary">{t("closures.table.allMembers")}</Badge>
          );
        }
        return (
          <span className="text-sm text-muted-foreground">
            {t("closures.table.memberCount", { count: members.length })}
          </span>
        );
      },
    },
    {
      id: "actions",
      header: () => (
        <div className="text-right">{t("closures.table.actions")}</div>
      ),
      cell: ({ row }) => <Action timeoff={row.original} />,
    },
  ];

  return columns;
}
